import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaCompleta from "../pages/guida-completa/page";
import SicurezzaAcquisti from "../pages/sicurezza-acquisti/page";
import ConfrontoCategorie from "../pages/confronto-categorie/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guida-completa",
    element: <GuidaCompleta />,
  },
  {
    path: "/sicurezza-acquisti",
    element: <SicurezzaAcquisti />,
  },
  {
    path: "/confronto-categorie",
    element: <ConfrontoCategorie />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;